// NextScene — cinematic two-column footer.
// Left: For Industry. Right: Company. Bottom: centered copyright.
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const H = { fontFamily: "'Ogg', 'Ogg Regular', 'Didot', 'Bodoni Moda', 'Playfair Display', Georgia, serif", color: "#F5F3EE" };
const linkStyle = {
  color: "rgba(255,255,255,0.72)",
  fontFamily: "'Inter', 'SF Pro Display', system-ui, sans-serif",
  fontSize: "14px",
  fontWeight: 400,
  display: "inline-flex",
  alignItems: "center",
  gap: "10px",
  textDecoration: "none",
  transition: "color 180ms ease",
};

function Column({ heading, items }) {
  return (
    <div>
      <div
        style={{
          ...H,
          fontSize: "22px",
          fontWeight: 400,
          letterSpacing: "-0.2px",
          paddingBottom: "6px",
          borderBottom: "2px solid #C79A2B",
          width: "fit-content",
          marginBottom: "26px",
        }}
      >
        {heading}
      </div>
      <ul className="flex flex-col" style={{ gap: "18px", margin: 0, padding: 0, listStyle: "none" }}>
        {items.map(([label, to]) => (
          <li key={label}>
            <Link to={to} data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`} style={linkStyle} className="ns-footer-link">
              <ChevronRight size={14} color="#C79A2B" />
              {label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      style={{
        backgroundColor: "#070709",
        borderTop: "1px solid rgba(199,154,43,0.14)",
        paddingTop: "64px",
        paddingBottom: "48px",
      }}
    >
      <div
        className="mx-auto ns-footer-grid"
        style={{
          maxWidth: "1200px",
          paddingLeft: "clamp(20px, 4vw, 56px)",
          paddingRight: "clamp(20px, 4vw, 56px)",
        }}
      >
        <Column
          heading="For Industry"
          items={[
            ["Cast Talent", "/cast-talent"],
            ["Advertise With Us", "/advertise"],
            ["Contact Us", "/contact"],
          ]}
        />
        <Column
          heading="Company"
          items={[
            ["FAQ", "/faq"],
            ["Careers", "/careers"],
          ]}
        />
      </div>
      <div style={{ maxWidth: "1200px", margin: "32px auto 0", paddingLeft: "clamp(20px, 4vw, 56px)", paddingRight: "clamp(20px, 4vw, 56px)" }}>
        <div style={{ height: "1px", background: "rgba(255,255,255,0.08)", marginBottom: "24px" }} />
        <p
          className="text-center"
          style={{
            margin: 0,
            fontFamily: "'Inter', 'SF Pro Display', system-ui, sans-serif",
            fontSize: "13px",
            color: "rgba(255,255,255,0.48)",
          }}
        >
          © 2026 nextscene. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
